import { isAdvisorStatusFilterValue } from './advisor-status';

/**
 * Persistence for the advisor-status filter (T20-3323).
 *
 * This is the only filter that survives a reload. The card asks for it to stay
 * set "unless the User adjusts the filter manually", so the value is written
 * through on every change and cleared by Clear Filters.
 *
 * Every access is guarded: localStorage throws in private-mode Safari and when
 * a browser blocks site data, and a filter preference is never worth breaking
 * the page over.
 */
const STORAGE_KEY = 'lre.filters.advisorStatus';

export function readStoredAdvisorStatus(): string | undefined {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    // A value that is no longer part of the vocabulary is discarded rather than
    // applied, so a removed status cannot strand someone on an empty list.
    return isAdvisorStatusFilterValue(stored) ? stored : undefined;
  } catch {
    return undefined;
  }
}

export function writeStoredAdvisorStatus(value: string | undefined): void {
  try {
    if (value === undefined) {
      window.localStorage.removeItem(STORAGE_KEY);
    } else {
      window.localStorage.setItem(STORAGE_KEY, value);
    }
  } catch {
    // A rejected write only means the preference will not survive this browser.
  }
}

export function clearStoredAdvisorStatus(): void {
  writeStoredAdvisorStatus(undefined);
}
